/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Дни доставки
   */
  app.DeliveryDays = app.Collection.extend({
    /**
     * Переопределен для создания вложенных коллекций с интервалами времени.
     * @param models Модели
     * @param options Опции
     */
    reset: function (models, options) {
      var newModels = [];
      _.each(models, function (model, index) {
        model = _.clone(model);
        if (model.delivery_interval) {
          var intervalsData = model.delivery_interval;
          _.each(intervalsData, function (interval, index) {
            if (!interval.id) {
              interval.id = index + 1;
            }
          });
          model.delivery_interval = new app.DeliveryIntervals();
          model.delivery_interval.reset(intervalsData);
        }
        if (!model.id) {
          model.id = index + 1;
        }
        newModels.push(model);
      });
      app.Collection.prototype.reset.apply(this, [newModels, options]);
    },
    
    model: app.DeliveryDay
    
  });
  
})();

}.call(window));